import { useMediaQuery } from '@mui/material';
import React from 'react';
import styled from 'styled-components';
import { DEVICES } from '../../const';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';


const Container = styled.div`
  background-image:	url("https://kangaroo-edu-main.s3.ap-northeast-2.amazonaws.com/landing-page/home/contact_header.jpg");
  background-size: cover;
  background-position: 52% 54%;
  position: relative;
  text-align: center;
  
  @media ${DEVICES.mobile} {
    padding: 96px 1.5rem;
  }
  
  @media ${DEVICES.tablet} {
    padding: 200px 1.5rem;
  }

  @media ${DEVICES.large} {
  }
`;

const ImageWrapper = styled.div`
  position: absolute;
  background-color: rgba(35, 46, 43, 0.7);
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
`;

const Heading = styled.div`
  color: #fff;
  position: relative;
  @media ${DEVICES.mobile} {
    font-size: 1.2rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 1rem;
  }

  @media ${DEVICES.laptop} {
    font-size: 1.25rem;
  }
`;

const Title = styled.div`
  color: #fff;
  position: relative;
  line-height: 1.3;
  font-weight: 700;
  margin-top: 1.5rem;

  @media ${DEVICES.mobile} {
    font-size: 2rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 2rem;
  }

  @media ${DEVICES.laptop} {
    font-size: 3rem;
  }
`;

const Description = styled.div`
  color: #fff;
  position: relative;
  
  @media ${DEVICES.mobile} {
    font-size: 1rem;
    margin-top: 2rem;
  }
  
  @media ${DEVICES.tablet} {
    font-size: 1rem;
    margin-top: 3rem;
  }

  @media ${DEVICES.laptop} {
    font-size: 1.25rem;
  }
`;

const IconWrapper = styled.div`
  position: relative;
  margin-top: 2.5rem;
  color: #fff;
`;

export default function ContactHeaderBanner() {

  const overTablet = useMediaQuery(`${DEVICES.tablet}`);

  const headingTemplate = () => {
    if (overTablet) {
      return <div>
        아이의 올바른 성장을 최우선으로 두고 몸과 마음이 <br />
        건강한 인격으로 성장시키기 위한 조력자가 되고자 합니다
      </div>
    }
    return <div>
      아이의 올바른 성장을 최우선으로 두고 몸과 마음이
      건강한 인격으로 성장시키기 위한 조력자가 되고자 합니다
    </div>
  }

  const titleTemplate = () => {
    if (overTablet) {
      return <>
        캥거루짐을 찾아준 아이들과 <br />
        좋은 인연으로 이어지길 희망합니다
      </>
    }
    return <>
      캥거루짐을 찾아준
      아이들과 좋은 인연으로
      이어지길 희망합니다
    </>
  }
  return <Container>
    <ImageWrapper>
    </ImageWrapper>
    <Heading>
      {headingTemplate()}
    </Heading>
    <Title>
      {titleTemplate()}
    </Title>
    <Description>
      수강생 중 이탈율은 10%도 되지 않습니다 <br />
      올해도 정원 모집이 빠르게 마감될 예정입니다
    </Description>
    <IconWrapper>
      <KeyboardArrowDownIcon fontSize='large' />
    </IconWrapper>
  </Container>
}
